export default __webpack_public_path__ + "static/media/loc-material-2.ce39545f.webp";